import PreRenderedElement from 'LayoutBuilderUI/components/placeholders/PreRenderedElement';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PreRenderedRichTextElement({
  children,
  ready = false
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!ready &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(PreRenderedElement, {
      className: "hs_cos_wrapper_type_rich_text"
    }), children &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      className: "hs_cos_wrapper_type_rich_text",
      style: {
        display: ready ? undefined : 'none'
      },
      children: children
    })]
  });
}
export default PreRenderedRichTextElement;